import Axios from "./index";

export const getMe = () => {
  return Axios.post(`/sasha/survey_questions`);
};

export const shouldAskQuestion = () => {
  return Axios.get(`/sasha/should_ask_question`);
};

export const getNextQuestion = () => {
  return Axios.get(`/sasha/next_question`);
};
export const askPrompt = (prompt, surveyQuestion = null) => {
  const obj = { prompt };
  if (surveyQuestion) {
    obj.survey = surveyQuestion;
  }
  return Axios.post(`/sasha/ask`, obj);
};
